import { useCallback, useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { listRankingSimulations } from "../../api/clientVendorDirectoryRankingApi";
import ClientVendorDirectorySubnav from "../../components/casamap/admin/ClientVendorDirectorySubnav";
import ClientVendorDirectoryRankingSubnav from "../../components/casamap/admin/ClientVendorDirectoryRankingSubnav";
import { ClientPortalError, ClientPortalLoading } from "../../components/clientPortal/ClientPortalStates";
import { formatClientDate, formatStatusLabel } from "../../utils/clientPortalFormat";
import { useLocale } from "../../intl";
import "../../styles/casamapaVendorDirectoryAdmin.css";

const COPY_PREFIX = "realEstate.casaMapa.admin.vendorDirectoryWorkspace.ranking.simulations";

export default function ClientVendorDirectoryRankingSimulationListPage() {
  const { clientViewId } = useParams();
  const { t, locale } = useLocale();
  const [simulations, setSimulations] = useState([]);
  const [loading, setLoading] = useState(true);
  const [errorMessage, setErrorMessage] = useState("");

  const load = useCallback(async () => {
    setLoading(true);
    try {
      const body = await listRankingSimulations(clientViewId);
      setSimulations(body.simulations || []);
    } catch (error) {
      setErrorMessage(error.message || t(`${COPY_PREFIX}.loadError`));
    } finally {
      setLoading(false);
    }
  }, [clientViewId, t]);

  useEffect(() => {
    load();
  }, [load]);

  return (
    <div className="page-content cvd-admin">
      <ClientVendorDirectorySubnav clientViewId={clientViewId} />
      <ClientVendorDirectoryRankingSubnav clientViewId={clientViewId} />
      <h1 className="cvd-admin__title">{t(`${COPY_PREFIX}.title`)}</h1>
      {loading ? <ClientPortalLoading message={t(`${COPY_PREFIX}.loading`)} /> : null}
      {errorMessage ? <ClientPortalError message={errorMessage} onRetry={load} /> : null}
      {!loading && !errorMessage ? (
        <div className="cvd-table-wrap">
          <table className="cvd-table">
            <thead>
              <tr>
                <th>{t(`${COPY_PREFIX}.table.proposedModel`)}</th>
                <th>{t(`${COPY_PREFIX}.table.status`)}</th>
                <th>{t(`${COPY_PREFIX}.table.scope`)}</th>
                <th>{t(`${COPY_PREFIX}.table.created`)}</th>
                <th>{t(`${COPY_PREFIX}.table.completed`)}</th>
              </tr>
            </thead>
            <tbody>
              {simulations.map((sim) => (
                <tr key={sim.id}>
                  <td>
                    {sim.proposed_model_name || sim.proposed_model_id} v{sim.proposed_model_version}
                  </td>
                  <td>{formatStatusLabel(sim.status)}</td>
                  <td>{sim.scope_type}</td>
                  <td>{formatClientDate(sim.created_at, locale)}</td>
                  <td>{sim.completed_at ? formatClientDate(sim.completed_at, locale) : "—"}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      ) : null}
    </div>
  );
}
